import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

import { ArchiveDocumentForm } from '@app/interfaces/archive-documents'

@Injectable()
export class DocumentService {
  private _archiveDocument: BehaviorSubject<ArchiveDocumentForm | null> = new BehaviorSubject<ArchiveDocumentForm | null>(null)

  setDocument (document: ArchiveDocumentForm) {
    this._archiveDocument.next(document)
  }

  getDocument () {
    return this._archiveDocument.asObservable()
  }
}
